import { useEffect } from 'react'


const useHumbleTheme = () => {
  useEffect(() => {
    document.body.classList.add('humbleLayout')
    document.body.classList.add('humbleBgColor')

    return () => {
      document.body.classList.remove('humbleLayout')
      document.body.classList.remove('humbleBgColor')
    }
  }, [])
}


export default useHumbleTheme
